import { connect, MapStateToProps } from "react-redux";

import { IAppState, QAProps } from "@multiweb/types/react";
import { createGetOrderedFrozenColumnKeys, createGetOrderedNonFrozenColumnKeys } from "../../selectors";
import { AggregationRowComponent, AggregationRowComponentProps } from "../AggregationRowComponent";

export type AggregationRowProps = {
    /** Klíč agregačního řádku. Prop je statická a po vytvoření komponenty ji nelze měnit. Využívá se k vytvoření selectorů. */
    aggregationRowKey: string;
} & QAProps;

type StateProps = Pick<AggregationRowComponentProps, "frozenColumns" | "nonFrozenColumns">;

const createMapStateToProps: (state: IAppState, props: AggregationRowProps) => MapStateToProps<StateProps, AggregationRowProps, IAppState> = (_state, { aggregationRowKey }) => {
    const getFrozenColumns = createGetOrderedFrozenColumnKeys();
    const getNonFrozenColumns = createGetOrderedNonFrozenColumnKeys();
    return (state) => ({
        frozenColumns: getFrozenColumns(state, { aggregationRowKey }),
        nonFrozenColumns: getNonFrozenColumns(state, { aggregationRowKey }),
    });
};

export const AggregationRow = connect(createMapStateToProps)(AggregationRowComponent);
